<tabbed-detail-base [tabs]="navTabs()" [(activeTabIndex)]="activeTabIndex">
  <span heading>{{ "ServiceElement.ConnectedNetworks" | translate }}</span>

  @if (activeEndpoint(); as endpoint) {
    <fw-endpoint-panel tab-content [endpoint]="endpoint" />
  }
</tabbed-detail-base>
